import styled from 'styled-components';

export const StyledAthletePage = styled.div`
  display: flex;
  flex-direction: column;
`;